module.exports = __webpack_public_path__ + "img/audit_agent.b64bcee4.png";